import {Box, Typography} from "@mui/material";

function SectionHeading({children}) {
    return (
        <Box sx={{mt: {xs: 5, md: 8}, mb: {xs: 2, md: 3}}}>
            <Typography variant="h4" color="primary" sx={{fontWeight: 700}}>
                {children}
            </Typography>
            <Box
                sx={{
                    mt: 1,
                    width: 56,
                    height: 4,
                    borderRadius: 2,
                    backgroundColor: 'primary.main',
                }}
            />
        </Box>
    );
}

export default SectionHeading;
